import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Switch,
  IconButton,
  Box,
  HStack,
  VStack,
  Textarea,
  useToast
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const FeesTypeModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feeGroup, setFeeGroup] = useState("");
  const [description, setDescription] = useState("");
  const [fields, setFields] = useState([{ type_name: "" }]);
  const [status, setStatus] = useState(false); // Assuming `status` might be part of the payload
  const toast = useToast();

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleFieldChange = (index, key, value) => {
    const updatedFields = [...fields];
    updatedFields[index][key] = value;
    setFields(updatedFields);
  };

  const addField = () => {
    setFields([...fields, { type_name: "" }]);
  };

  const removeField = (index) => {
    const updatedFields = fields.filter((_, i) => i !== index);
    setFields(updatedFields);
  };

  const handleSubmit = async () => {
    const payload = {
      group_name: feeGroup,
      description,
      org_id: sessionStorage.getItem('cmp_id'), // Replace with actual `org_id`
      user_id: sessionStorage.getItem('user_id'), // Replace with actual `user_id`
      fee_types: fields,
    };

    console.log(payload);
    

    try {
      const response = await fetch(
        `${BASE_URL}/admin/Fees/fees_group/add_fee_group.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      

      const result = await response.json();
      console.log(result);

      if (result.success) {
        toast({
          title: "Success",
          description: result.message,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        closeModal();
      } else {
        toast({
          title: "Error",
          description: result.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Something went wrong. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Button
        className="add-teacher-button"
        onClick={openModal}
        leftIcon={<AddIcon />}
        colorScheme="teal"
      >
        <Box display={{ base: "none", md: "block" }}>Fees Group</Box>
      </Button>
      <Modal isOpen={isOpen} onClose={closeModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Fees Group and Types</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch" mb={4}>
              <FormControl>
                <FormLabel>Fee Group</FormLabel>
                <Input
                  placeholder="Enter Fee Group"
                  value={feeGroup}
                  onChange={(e) => setFeeGroup(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Description</FormLabel>
                <Textarea
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>
            </VStack>
            <FormLabel>Fee Type</FormLabel>
            {fields.map((field, index) => (
              <Box key={index} mb={4}>
                <HStack spacing={4} align="start">
                  <FormControl>
                    <Input
                      placeholder="Enter Fee Type Name"
                      value={field.type_name}
                      onChange={(e) =>
                        handleFieldChange(index, "type_name", e.target.value)
                      }
                    />
                  </FormControl>
                  <IconButton
                    icon={<DeleteIcon />}
                    colorScheme="red"
                    size="sm"
                    aria-label="Remove Field"
                    onClick={() => removeField(index)}
                  />
                </HStack>
              </Box>
            ))}
            <Button
              colorScheme="blue"
              size="sm"
              leftIcon={<AddIcon />}
              onClick={addField}
            >
              Add Fee Type
            </Button>
            <FormControl mt={6}>
              <FormLabel>Status</FormLabel>
              <Switch
                colorScheme="blue"
                isChecked={status}
                onChange={(e) => setStatus(e.target.checked)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button onClick={closeModal} mr={3}>
              Cancel
            </Button>
            <Button colorScheme="blue" onClick={handleSubmit}>
              Save Fees Group
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default FeesTypeModal;
